import { Link } from "react-router-dom";

export function LogoMark({ size = 36, className = "" }) {
  return <img src="/brand/icon.png" width={size} height={size} alt="EasyVideo" className={className} style={{ objectFit: "contain" }} />;
}

export function Logo({ dark = false, to = "/", size = 34 }) {
  return (
    <Link to={to} className="flex items-center gap-2.5 group" data-testid="brand-logo">
      <LogoMark size={size} className="transition-transform duration-300 group-hover:scale-105" />
      <span className={`font-heading font-extrabold text-2xl tracking-tight ${dark ? "text-white" : "text-brand-purpleDeep"}`}>
        easy<span className="text-brand-purple">video</span>
      </span>
    </Link>
  );
}
